import AwsSA from "../../../assets/images/aws-sa.png";

import "./About.scss";

const About = () => {
  return (
    <>
      <h3>
        I'm a <b>Senior Software Engineer</b> from Lithuania, Vilnius.{" "}
      </h3>
      <p>
        12+ years background in creating and executing innovative software solutions to enhance business productivity.
      </p>
      <p>
        Committed to delivering custom solutions that optimize business processes and enhance user experiences.
        Experienced in web and desktop application development, I offer a solid track record of creating efficient and
        innovative solutions for diverse clients.
      </p>
      <a href="https://www.credly.com/badges/e16f44cd-2fc9-4411-8091-bc902005f470/public_url" target="_blank" rel="noreferrer">
        <img src={AwsSA} alt="AWS Certified Solutions Architect badge" />
      </a>
    </>
  );
};

export default About;
